export default __webpack_public_path__ + "maps-examples-source-custom-vector-thumbnail-480-a5f44a0b2ec4508f7761fbda4d8ad12e.webp";